<template>
    <TermsCheck
        :content="listText"
        :isLoading="isLoading"
        :hasTitle="true"
        @goNext="goNext"
    />
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { getAgreeTermsMultiENotify, postAgreeMultiENotify } from '@/apis/aplCatlMultiENotify';
import routeName from '@/router/constant.js';
import TermsCheck from '@/components/template/TermsCheck.vue';

export default {
    components: {
        TermsCheck
    },
    setup() {
        const router = useRouter();
        const listText = ref('');
        const isLoading = ref(false);

        /** 取得條款內容 */
        getAgreeTermsMultiENotify().then((res) => {
            listText.value = res.data.agreeTerms.content;
        });

        const goNext = () => {
            isLoading.value = true;
            postAgreeMultiENotify().then(() => {
                router.push({
                    name: routeName.MULTI_ENOTIFY
                });
            }).finally(() => {
                isLoading.value = false;
            });
        };
        return {
            listText,
            isLoading,
            goNext
        };
    },
};
</script>
